import { simReducer } from './simulationReducer';
import { STEP_SIZE } from '../containers/Onboarding/RetirementAmountNeeded';

const simulationReducer = simReducer('GUARANTEED_INCOME_', ['distribution']);

const initialState = {
  fetched: false,
  data: null,
  spendingSources: {},
  simulation: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GUARANTEED_INCOME_MODULE_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, { fetched: true, data: action.payload });
      } else {
        return { fetched: true, data: null };
      }
    case 'GUARANTEED_INCOME_SIMULATION_STARTED':
    case 'GUARANTEED_INCOME_SIMULATION_FINISHED':
      return Object.assign({}, state, { simulation: simulationReducer(state.simulation, action) });
    case 'GUARANTEED_INCOME_SPENDING_SOURCES_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, {
          fetched: true,
          spendingSources: Object.assign({}, state.spendingSources, {
            [action.payload.withdrawalRate]: action.payload.data,
          }),
        });
      } else {
        return { fetched: true, data: null };
      }
    default:
      return state;
  }
};
